/* =========================================================
   The SEDUCTION Bundle — behavior
   Vanilla port. Includes affiliate checkout routing.
   ========================================================= */
(function () {
  /* ---- AFFILIATE CHECKOUT ROUTING ----
     Add rows to AFFILIATES to give each affiliate their own link.
     ?affiliate=jake  ->  AFFILIATES.jake ; anything else -> DEFAULT. */
  var DEFAULT_CHECKOUT = 'https://seduction-lab.com/cart/57333667725699:1';
  var AFFILIATES = {
    // 'jake': 'https://seduction-lab.com/cart/57333667725699:1?ref=jake'
  };

  function resolveCheckout() {
    var key = '';
    try { key = (new URLSearchParams(window.location.search).get('affiliate') || '').trim().toLowerCase(); }
    catch (e) { var m = window.location.search.match(/[?&]affiliate=([^&]+)/i); key = m ? decodeURIComponent(m[1]).trim().toLowerCase() : ''; }
    if (key && Object.prototype.hasOwnProperty.call(AFFILIATES, key)) return AFFILIATES[key];
    return null;
  }

  function applyCheckout(root) {
    var url = resolveCheckout();
    if (!url) return; // keep the Liquid cta_link when no affiliate matches
    Array.prototype.slice.call(root.querySelectorAll('a[data-checkout]')).forEach(function (a) {
      a.setAttribute('href', url);
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener');
    });
  }

  function init() {
    var root = document;
    applyCheckout(root);

    var reveals = Array.prototype.slice.call(root.querySelectorAll('[data-reveal]'));
    reveals.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(26px)';
      el.style.transition = 'opacity .8s cubic-bezier(.2,.8,.2,1), transform .8s cubic-bezier(.2,.8,.2,1)';
    });
    if ('IntersectionObserver' in window) {
      var ro = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.style.opacity = '1'; e.target.style.transform = 'translateY(0)'; ro.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
      reveals.forEach(function (el) { ro.observe(el); });
    } else {
      reveals.forEach(function (el) { el.style.opacity = '1'; el.style.transform = 'none'; });
    }

    var progress = root.getElementById('sb-progress');
    var nav = root.getElementById('sb-nav');
    var arcfill = root.getElementById('sb-arcfill');
    var arcSection = arcfill ? arcfill.closest('section') : null;

    var onScroll = function () {
      var st = window.scrollY;
      var docH = document.documentElement.scrollHeight - window.innerHeight;
      if (progress) progress.style.width = ((docH > 0 ? st / docH : 0) * 100).toFixed(2) + '%';
      if (nav) {
        var on = st > 40;
        nav.style.background = on ? 'rgba(11,10,9,0.94)' : 'rgba(11,10,9,0)';
        nav.style.borderBottomColor = on ? 'rgba(255,255,255,0.08)' : 'rgba(255,255,255,0)';
        nav.style.backdropFilter = on ? 'blur(10px)' : 'blur(0px)';
        nav.style.webkitBackdropFilter = on ? 'blur(10px)' : 'blur(0px)';
      }
      if (arcfill && arcSection) {
        var r = arcSection.getBoundingClientRect();
        var p = (window.innerHeight * 0.75 - r.top) / (r.height * 0.62);
        p = Math.max(0, Math.min(1, p));
        arcfill.style.height = (p * 100).toFixed(1) + '%';
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();

    var sticky = root.getElementById('sb-sticky');
    var hero = root.getElementById('sb-hero');
    if (sticky && hero && 'IntersectionObserver' in window) {
      var so = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { sticky.style.transform = e.isIntersecting ? 'translateY(120%)' : 'translateY(0)'; });
      }, { threshold: 0 });
      so.observe(hero);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
